<template>
    <div class="row">
        <div id="ticketsLogsSpinner"></div>
        <div class="e-card mt-2">
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref='grid'
                              :dataSource='tradeLogData'
                              :allowPaging='true'
                              :allowResizing='true'
                              :allowReordering='false'
                              :allowSorting='false'
                              :allowFiltering='true'
                              :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete'
                              :filterSettings='filterOptions'
                              :autoFit='true'
                              :pageSettings='pageSettings'
                              :actionComplete='actionComplete'
                              :excelQueryCellInfo='excelQueryCellInfo'
                              :toolbar='toolbar'
                              :actionBegin ='actionBegin'
                              :toolbarClick='toolbarClick'
                              :actionFailure='actionFailure'
                              :queryCellInfo='customiseCell'>
                        <e-columns>
                            <e-column field='ticketLogId' headerText='Trade Log ID' width=120></e-column>
                            <e-column field='ticketId' headerText='Trade ID'></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' width=150></e-column>
                            <e-column field='tradeDate' headerText='Trade Date' type="date" :format='dateFormatOptions'></e-column>
                            <e-column field='contractTradeablePeriodName' headerText='Trade Period'></e-column>
                            <e-column field='productName' headerText='Product'></e-column>
                            <e-column headerText='Complex trade' field='partOfComplexTrade' textAlign="Center"></e-column>
                            <e-column headerText='Locked Volume' field='lockedVolume' textAlign="Center"></e-column>
                            <e-column headerText='Trading Unit' field='volumeUnitName' textAlign="Center"></e-column>
                            <e-column headerText='Volume Hedged Percentage' field='volumeHedgedPercentage' textAlign="Center"></e-column>
                            <!--<e-column headerText='Volume in Market Volume Unit' field='calculatedLockedVolume' textAlign="Center"></e-column>-->

                            <e-column headerText='Market Volume Unit' field='tradingUnitName' textAlign="Center"></e-column>
                            <e-column field='price' headerText='Price' format="n3" textAlign="Center"></e-column>
                            <e-column field='tradedBy' headerText='Traded by' textAlign="Center"></e-column>
                            <e-column field='confirmationReference' headerText='Confirmation Reference' textAlign="Center"></e-column>
                            <e-column field='supplementaryNote' headerText='Supplementary Note' textAlign="Center"></e-column>
                            <e-column field='deleted' headerText='Is Deleted' textAlign='Center' type='string'></e-column>
                            <e-column field='childTicket' headerText='Is Child Ticket' textAlign='Center' type='string'></e-column>
                            <e-column field='ticketLogDate' headerText='Log Date' textAlign='Left' type="date" :format='dateFormatOptions'></e-column>
                            <e-column field='ticketLogDate' headerText='Log Time' textAlign='Left' type='string'></e-column>
                            <e-column field='userName' headerText='User' textAlign='Left' type="string"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Vue from 'vue';
    import { GridPlugin, Filter, Resize, ForeignKey, Toolbar, ExcelExport, Page } from '@syncfusion/ej2-vue-grids';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import store from '../../store';
    import gridOptions from '../../common/gridOptions';
    import apis from '../../common/network';
    import authToken from '../../common/authToken';
    import { createSpinner, showSpinner, hideSpinner, DialogUtility } from '@syncfusion/ej2-popups';

    Vue.use(ButtonPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogPlugin);
    Vue.use(GridPlugin);

    export default {
        name: 'TicketsLogsReport',
        created() {
        },
        data() {
            return {
                store: store,
                tradeLogData: {},
                filterOptions: gridOptions.filterSettings,
                pageSettings: gridOptions.pageSettings,
                toolbar: ['ExcelExport'],
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } }
            };
        },
        mounted() {
            showSpinner(document.getElementById('mainSpinner'));
            this.getTradeLogData();
        },
        methods: {
            getTradeLogData: function () {

                apis.protectedApi(`report/tradeLogs/${store.state.reportContractId}`)
                    .then(response => {
                         hideSpinner(document.getElementById('ticketsSpinner'));
                        this.tradeLogData = response.data.result;
                        this.tradeLogData.forEach(item => {
                            item.tradeDate = new Date(item.tradeDate);
                            item.ticketLogDate = new Date(item.ticketLogDate);
                        });
                    }).catch(e => {
                        hideSpinner(document.getElementById('ticketsSpinner'));
                        if (e.response) {
                            this.showAlertDialog(e.response.data.message);
                        }
                    })
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            },
            showAlertDialog: function (message) {
                DialogUtility.alert({
                    title: "Alert",
                    content: message,
                    showCloseIcon: false,
                    closeOnEscape: true,
                    position: { X: 700, Y: 200 },
                    animationSettings: { effect: "Zoom" },
                    zIndex: 1100

                });
            },
            customiseCell: function (args) {
                //if (args.column.field === 'lockedVolume') {
                //    args.cell.textContent = args.cell.textContent + " " + args.data.volumeUnitName;
                //}
                if (args.column.field === 'volumeHedgedPercentage') {
                    args.cell.textContent = args.cell.textContent + "%";
                }
                if (args.column.field === 'price') {
                    args.cell.textContent = args.data.price + " " + args.data.priceUnitName;
                }
                if (args.column.headerText === 'Log Time') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['ticketLogDate']);
                }

            },
            excelQueryCellInfo: function (args) {
                //if (args.column.field === 'lockedVolume') {
                //    args.value = args.value + " " + args.data.volumeUnitName;
                //}
                if (args.column.field === 'volumeHedgedPercentage') {
                    args.value = args.value + "%";
                }
                if (args.column.field === 'price') {
                    args.value = args.data.price + " " + args.data.priceUnitName;
                }
                if (args.column.headerText === 'Log Time') {
                    args.value = this.convertUTCDateToLocalTime(args.data['ticketLogDate']);
                }
                if (args.column.headerText === 'Log Date') {
                    args.value = this.convertUTCDateToLocaDate(args.data['ticketLogDate']);
                }
                if (args.column.headerText === 'Trade Date') {
                    args.value = this.formatDate(args.data['tradeDate']);
                }

            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            },
            formatDate(dateString) {
                const date = new Date(dateString)
                return date.toLocaleDateString();
            },
            toolbarClick(args) {
                gridOptions.excelExport(args, "Trades Logs.xlsx", this.$refs);
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            }
        },
        provide: {
            grid: [ Filter, Resize, ForeignKey, Toolbar, ExcelExport, Page ]
        }
    };
</script>

<style scoped>
</style>